export const LOAD_HOME_MAP = 'LOAD_HOME_MAP';

export function loadHomeMap(data) {
  return {type,data}
}
